export const VALID_GUESSES = [
 'Johnny Depp',
 'Emma Watson',
 'Liam Neeson',
 'Naomi Watts',
 'Salma Hayek',
 'Ben Affleck',
 'Halle Berry',
 'Bill Murray',
 'John Cleese',
 'Uma Thurman'
]
